module.exports = __webpack_public_path__ + "static/media/home_banner.7df7c4ff.jpg";